<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2022-10-27 18:21:14
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-01 00:38:22
-->
<template>
  <div class="bg">
    <BaseImg :option="{style: {'margin-top':'14px','margin-left':'16px',width: '71px','align-self': 'flex-start'},url: 'logo.png',}"/>
    <!-- <div class="bgImg"></div> -->
    <BaseImg :option="{style: {'margin':'10px auto 0'},url: 'game-header.png',}"/>

    <div class="game_main">
      <!-- <img :src="`${imgHost}game_bg.png?v=${$config.OSSVersion}`"/> -->
      <img class="game_bg" :src="`${imgHost}game_bg.png?v=${$config.OSSVersion}`" />
      <div class="prizeList">
        <img class="prizeItem" 
        v-for="(item,index) in prize_list1"
        :key="`index${index}`"
        @click="prize(item)"
        :src="`${imgHost}prize/${item.inStock==1?item.prizeIcon2:item.prizeIcon||'fail_prize'}.png?v=${$config.OSSVersion}`"
        />
      </div>
      <div class="show">
        <div class="game-info1" >已领取:{{num}}</div>
        <div class="game-info2">剩余抽奖次数：{{gameCounts}}</div>
        <div class="game-info3">未领取:{{remainingPrizes}}</div>
      </div>
       <div :class="['zhua',{open}]">
        <img class="zhua1" :src="`${imgHost}zhua1.png?v=${$config.OSSVersion}`" />
        <div class="zhua2" v-show="zhuaImg==2" :style="{ backgroundImage: `url(${imgHost}zhua2.png?v=${$config.OSSVersion})` }"></div>
        <div class="zhua3" v-show="zhuaImg==3" :style="{ backgroundImage: `url(${imgHost}zhua3.png?v=${$config.OSSVersion})` }"></div>
      </div>
      <img class="prize" :src="`${imgHost}prize.png?v=${$config.OSSVersion}`" />
      <img class="glass" :src="`${imgHost}glass.png?v=${$config.OSSVersion}`" />
      
      <div  class="btn" v-if="showBtn">
        <img :src="`${imgHost}btn.png?v=${$config.OSSVersion}`" @click="handleStart"/>
        <div @click="handleStart"></div>
      </div>
      
      <div  class="btn2" v-else>
        <img :src="`${imgHost}btn.png?v=${$config.OSSVersion}`" @click="handleStart"/>
        <div @click="handleStart"></div>
      </div>
      
      <div class="avatar-list">
        <div class="item" v-for="(item,index) in friendList" :key="index" @click="avatar(item)">
          <div class="avatar-item">
            <img :src="item.headImg"/>
            <span>{{item.nickName}}</span>
          </div>
          <img class="arrow" v-show="index!=friendList.length-1" :src="`${imgHost}game_arrow.png?v=${$config.OSSVersion}`"/>
        </div>
      </div>
      <span class="tip">活动期间每分享1位好友即可增加1次抽奖机会</span>
    </div>
    <BasePaySuccess ref="PaySuccess" />

    <div :class="['blindbox',{animate:showPrizeModel}]" v-show="showPrizeModel">
      <div class="info">
        <BaseImg :option="{url: 'bolindbox.png',}"/>
        <BaseImg @click="getLottery" :option="{style: {'margin':'15px auto 0',width: '180px'},url: 'bolindbox_btn.png',}"/>
      </div>
    </div>
    <BaseBtnHome/>
  </div>
</template>

<script>
import { MessageBox } from "mint-ui";
export default {
  components: {},

  data() {
    return {
      gameCounts: 0, //设置抽奖次数
      remainingPrizes:0, // 剩余奖品数
      click: true, //是否禁止抽奖
      prizeId: 0, // 中奖id
      open: false,
      zhuaImg:2,
      userList:[
        {headImg:`${this.$config.imgHost}avatar.png?v=${this.$config.OSSVersion}`,nickName:'好友1',isShare:true},
        {headImg:`${this.$config.imgHost}avatar.png?v=${this.$config.OSSVersion}`,nickName:'好友2',isShare:true},
        {headImg:`${this.$config.imgHost}avatar.png?v=${this.$config.OSSVersion}`,nickName:'好友3',isShare:true},
        {headImg:`${this.$config.imgHost}avatar.png?v=${this.$config.OSSVersion}`,nickName:'好友4',isShare:true},
        {headImg:`${this.$config.imgHost}avatar.png?v=${this.$config.OSSVersion}`,nickName:'好友5',isShare:true},
        {headImg:`${this.$config.imgHost}avatar.png?v=${this.$config.OSSVersion}`,nickName:'好友6',isShare:true},
      ],
      friendList:[],
      prizeList:[],
      showPrizeModel:false,
      prize_list1:[],
      num:0,
      isFixed:0,
      showBtn:false,
    };
  },
  created() {
    this.getCount();
    this.getPrizeCount()
    this.getPrize()
    this.getmygiftList();
    this.getRankingList();
  },
  mounted() {
    this.$wx.shareCallBackFunList.push("share2", async () => {
      this.$modal.drawForm.close()
      await this.getCount()
      await this.getPrizeCount()
    });
    
        window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll(){
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if(scrollTop>=93){
        this.showBtn=true
      }else{
        this.showBtn=false
      }
    },
    async getCount() {
      const data = await this.$httpdf.get(this.apiHost + 'user/gameCount')
      if (data.code == 0) {
        this.gameCounts = data.data.gameCount
      }
    },
    //我的礼品列表
    async getmygiftList() {
      const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/myPrize', {
        filterRule: 1
      })
      if (data.code == 0) {
        let prize_list1 =[]
        let num=0
        let  isFixed=0
        data.data.forEach(item=>{
          if(item.isFixed==0||item.isFixed==1){
            prize_list1.push(item)
            if(item.status==3||item.status==4){
              num+=1;
              isFixed=1
            }
          }
        })
        this.isFixed=isFixed;
        this.num=num
        const prizeList=[
          {countTime:'',prizeIcon:'fail_prize',prizeIcon2:'fail_prize',},
          {countTime:'',prizeIcon:'fail_prize',prizeIcon2:'fail_prize',},
          {countTime:'',prizeIcon:'fail_prize',prizeIcon2:'fail_prize',},
          {countTime:'',prizeIcon:'fail_prize',prizeIcon2:'fail_prize',},
          {countTime:'',prizeIcon:'fail_prize',prizeIcon2:'fail_prize',},
          {countTime:'',prizeIcon:'fail_prize',prizeIcon2:'fail_prize',},
        ]
        if(prize_list1.length<6){
          prize_list1=prize_list1.concat(prizeList.splice(prize_list1.length,6))
        }
        this.prize_list1=prize_list1;
      } else if (data.code !== 0) {
        this.$showModal(data.msg || "网络不佳，请稍后再试！");
      }
    },
    async getRankingList() {
      const data = await this.$httpdf.get(this.apiHost + 'assistance/myFriends')
      if (data.code == 0) {
        let  friendList = data.data.filter((v)=> v!=null)
        if(friendList.length<6){
          friendList=friendList.concat(this.userList.splice(friendList.length,6))
        }
        this.friendList=friendList
      }
    },
    handleStart() {
      console.log(this.gameCounts)
      if (this.gameCounts <= 0) {
         this.$modal.drawForm.alert({
          drawTxt: 1,
          thanksTxt: `抽奖机会用完了，推荐好友<br />参与活动还能获得更多「金喜」`,
          btnStatus: 1
        })
        return 
      }
      if(this.open){
        return 
      }
      // this.$modal.drawForm.alert({ prizeId: this.prizeId })
      this.open=true
      setTimeout(() => {
        this.zhuaImg = 3;
      }, 1000);
      setTimeout(() => {
        this.showPrizeModel=true
      }, 2000);
      // this.getLottery();
    },
    // 抽奖
    async getLottery() {
      if (!this.click) {
        return;
      }
      this.gameCounts--;
      this.click = false;
      console.log("======>调用抽奖接口", 2);
      let that = this;
      that.click = false;
      //获取奖品
      const data = await that.$httpdf.get(this.apiHost + 'dongYuan/lottery')
      if (data.code == 0) {
        this.prizeId = data.data;
        if (this.prizeList.length > 0) {
          this.prizeList.forEach((v, i) => {
            if (v.id == this.prizeId) {
              this.prize = i;
              console.log(this.prize,'prize');
              return;
            }
          });
        }
      } else {
        this.prize = 7;
      }
      this.showPrize()
    },
    showPrize() {
      if (this.prize != 7) {
        this.$modal.drawForm.alert({ prizeId: this.prizeId,drawTxt: 2 }).then(async ()=> {
          // await this.getCount()
          // if (this.gameCounts === 0) {
          //   this.$modal.drawForm.alert({
          //       drawTxt: 1,
          //       thanksTxt: `抽奖机会用完了，推荐好友<br />参与活动还能获得更多「金喜」`,
          //       btnStatus: 1
          //   })
          // } 
          this.showPrizeModel=false
          this.$refs['PaySuccess'].getPaySuccess()
        })
      } else {
        this.$modal.drawForm.alert({
            drawTxt: 3,
            thanksTxt: `奖品偷偷溜走啦！<br />再来一次中奖机会更大哦！`,
            btnStatus: 1
          }
        ).then(async () => {
          await this.getCount()
          if (this.gameCounts === 0) {
            this.$modal.drawForm.alert({
              drawTxt: 1,
              thanksTxt: `抽奖机会用完了，推荐好友<br />参与活动还能获得更多「金喜」`,
              btnStatus: 1
            })
          }
          this.showPrizeModel=false
          this.$refs['PaySuccess'].getPaySuccess()
        });
      }
      this.open=false
      this.click=true
      this.zhuaImg = 2;
      this.getmygiftList();
    },
    
    async getPrizeCount() {
      const data = await this.$httpdf.get(this.apiHost + 'dongYuan/prizeResidue')
      if (data.code == 0) {
        console.log(data)
        this.remainingPrizes = data.data
      }
    },
    async getPrize () {
      const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/view')
      if (data.code == 0) {
        this.index = ''
        this.prizeList = data.data
        // this.prizeList = [...this.prizeList, ]
      } else {
        MessageBox.alert(data.msg)
      }
    },
    avatar(item){
      if(item.isShare){
        this.goShare()
      }
    },
    prize(item){
      if(!item.prizeId){
        return 
      }
      if(this.isFixed){
        this.$showModal("已达到领取上限!");
        return 
      }
      console.log(item)
      if(item.status==2){
        
        this.timeStatus = false
        this.$modal.drawForm.alert({ prizeId: item.prizeId, isMyprize: true,drawTxt: 2 }).then(()=> {
          this.timeStatus = true
          this.getmygiftList()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
div{
  position: relative;
}
.bg {
  background: linear-gradient(0deg, #FCC229 0%, #FDD142 49%, #FDD94F 100%);

  .bgImg{
    position: absolute;
    z-index:0;
    width: 343px;
    height:244px;
    background-image: url( $imgHost + 'bg.png?v=' + $OSSVersion);
    background-position: top center;
    background-size: 100% auto;
    border: 1px solid #231815;
    border-radius: 0px 0px 62px 0px;
    top:51px;
  }
  // 游戏页
  .game_main {
    position: relative;
    padding-bottom:10px;
    // margin-top:12px;
    .game_bg{
      width:100%;
    }
    .prizeList{
      position: absolute;
      top:31px;
      left:59px;
      width:256px;
      display:flex;
      align-items: center;
      overflow-x:auto;
      img{
        width:36px;
        margin-right:8px;
        &:last-child{
          margin-right:0;
        }
      }
    }
    .show{
      position: absolute;
      top:86px;
      left:25px;
      @extend .flex-center-center;
      height: 22px;
      text-align: center;
      line-height: 22px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      .game-info1{
        background: #FDD142;
        border: 1px solid #211816;
        color: #211816;
        border-radius: 11px;
        width: 80px;
      }
      .game-info2{
        background: #211816;
        color: #FFFFFF;
        border-radius: 11px;
        width: 150px;
        margin-left: 8px;
      }
      .game-info3{
        background: #DA6734;
        border: 1px solid #211816;
        color: #FFFFFF;
        width: 80px;
        border-radius: 11px;
        margin-left: 8px;
      }
    }
    
    .open{
      &.zhua{
        animation-play-state:paused,running;
        animation-name: zhua_animate,zhua_move_animate;
      }
    }
    .zhua{
      position: absolute;
      top: 132px;
      left: 40px;
      width: 66px;
      height: 103px;
      animation-timing-function: linear;
      animation-duration: 5s,2s;
      animation-iteration-count:infinite,1;
      animation-name: zhua_animate,none;
      animation-play-state:running,paused;
      .zhua1{
        position: absolute;
        width: 12px;
        left:27px;
      }
      .zhua2,.zhua3{
        width: 66px;
        background-size: 66px auto;
        background-position: center bottom;
        position: absolute;
        top: 0;
        bottom: 20px;
        z-index :3;
      }
    }
    .prize{
      position: absolute;
      top:203px;
      left:42px;
      width:294px;  
      z-index:4;
    }
    .glass{
      position: absolute;
      top:132px;
      left:42px;
      width:294px;
      z-index:4;
    }
    .btn{
      position: absolute;
      top:352px;
      width:214px;
      left:81px;
      div{
        position: absolute;
        width:100%;
        height:100%;
        top:0;
        left:0;
        z-index:99;
      }
    }  
    .btn2{
      position: fixed;
      width:214px;
      left:81px;
      bottom:40px;
      z-index:9;
      div{
        position: absolute;
        width:100%;
        height:100%;
        top:0;
        left:0;
        z-index:99;
      }
    }

    .avatar-list{
      position: absolute;
      width:290px;
      left:42.5px;
      top:430px;
      display: flex;
      align-items: center;
      overflow-x:auto;
      .item{
        display: flex;
        align-items: center;
        .avatar-item{
          position: relative;
          text-align: center;
          width:36px;
          img{
            margin: 4px 0;
            border-radius: 20px;
          }
          span{
            display:block;
            width:36px;
            text-align: center;
            color: #DA6734;
            line-height: 20px;
            font-size:10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .arrow{
          position: relative;
          width:17px;
          margin:0 6px ;
          margin-bottom: 20px;
        }
      }
    }
    .tip{
      position: absolute;
      top:513px;
      width:100%;
      left:0;
      text-align: center;
      font-size: 10px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #231815;
    }
  }
  .blindbox{
    position: fixed;
    width:100%;
    height:100vh;
    background: rgba(0,0,0,0.7);
    top:0;
    left:0;
    z-index:99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .info{
      animation-timing-function: ease-out;
      animation-duration: 1s;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
      transform: scale(0)
    }
  }
}

@keyframes modal_animate {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
.animate{
  .info{
    animation-name:modal_animate;
  }
}

@keyframes zhua_animate {
  0% {
    left :40px;
  }
  50% {
    left:270px;
  }
  100%{
    left:40px;
  }
}

@keyframes zhua_move_animate {
  0% {
    height: 103px;
  }
  50% {
    height: 227px;
  }
  100%{
    height: 103px;
  }
}
</style>
